module.exports = __webpack_public_path__ + "images/emoji/gift_heart.773a9609e8c47ca2cc26.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/gift_heart.png
// module id = E/Y5
// module chunks = 24